import React from 'react';
import { Navbar, NavbarBrand, Container } from 'reactstrap';
import Logo from '../../../assets/images/verbund_logo.svg';

function Header() {
  return (
    <Navbar color="#fff" light expand="md">
      <Container>
        <NavbarBrand href="https://www.verbund.com/">
          <img src={Logo} height={30} alt="Logo - Verbund" />
        </NavbarBrand>
      </Container>
    </Navbar>
  );
}
export default Header;
